/**
 * RmmAdmin.tsx — Admin → Marketplace → Partell Pharmacy.
 * Thin wrapper over the reusable LabIntegrationAdmin.
 *
 * Partell has no vendor catalog: staff submit a real prescription (drug, sig,
 * refills, ICD-10, prescriber NPI/DEA) rather than picking a SKU. What this
 * page manages is therefore the module itself — enable/disable per practice and
 * the per-account RMM credentials — plus the flat in-app fee charged for
 * submitting an Rx, which is the one priceable item the integration has.
 */
import { LabIntegrationAdmin } from '@/pages/admin/LabIntegrationAdmin';

export function RmmAdmin() {
  return (
    <LabIntegrationAdmin
      integrationKey="rmm"
      title="Partell Pharmacy"
      subtitle="Compounded / Rx prescriptions submitted to Partell via the RequestMyMeds API"
      vendorName="Partell"
    />
  );
}
